import { useUploadStore } from "@components/FileUpload/uploadStore";

export const DEFICIENCY_APPROVE_ATTACHMENTS_UPLOAD_KEY = "deficiencyApproveAttachments";
export const DEFICIENCY_REJECT_ATTACHMENTS_UPLOAD_KEY = "deficiencyRejectAttachments";
export const DEFICIENCY_RESOLUTION_PROOF_UPLOAD_KEY = "deficiencyResolutionProof";

export const DEFICIENCY_DETAILS_DRAWER_UPLOAD_KEYS = [
  DEFICIENCY_APPROVE_ATTACHMENTS_UPLOAD_KEY,
  DEFICIENCY_REJECT_ATTACHMENTS_UPLOAD_KEY,
  DEFICIENCY_RESOLUTION_PROOF_UPLOAD_KEY,
] as const;

export const clearPersistedDeficiencyDrawerUploads = () => {
  const uploadStore = useUploadStore.getState();

  DEFICIENCY_DETAILS_DRAWER_UPLOAD_KEYS.forEach((key) => {
    uploadStore.clearFilesForKey(key);
  });
};
